import { gql } from "@apollo/client";

export const GET_CIERRE_BOTON = gql`
query cierreBoton($boton: Int!, $idPeriodo: Int!) {
    cierreBoton(boton: $boton, idPeriodo: $idPeriodo) 
}`;